// import { useState, useRef } from "react";

// const CATEGORIES = ["Plumbing", "Electrical", "Security", "Housekeeping", "Parking", "Noise", "Common Area", "Other"];

// const STATUS_STYLE = {
//   Pending: { bg: "#FBF0DA", fg: "#8A5A0E", dot: "#C98A2C" },
//   "In Review": { bg: "#DCE8F5", fg: "#1F4E85", dot: "#2563A6" },
//   Resolved: { bg: "#DFEEE5", fg: "#1F5C41", dot: "#2F7D5C" },
// };

// const PRIORITY_STYLE = {
//   Low: { fg: "#5A6B62", bg: "#E4E9E5" },
//   Medium: { fg: "#8A5A0E", bg: "#FBF0DA" },
//   High: { fg: "#A6321F", bg: "#F7DEDA" },
// };

// function genId() {
//   const n = Math.floor(1000 + Math.random() * 9000);
//   return `CMP-${new Date().getFullYear()}-${n}`;
// }

// // Logged-in session — in a real app this comes from auth, not a form.
// const SESSIONS = {
//   Resident: { name: "Rohan Sharma", unit: "B-204", phone: "98XXXXXX21" },
//   AOA: { name: "Committee Office", unit: "Admin Block", phone: "98XXXXXX00" },
// };

// export default function ComplaintRegister({ role = "Resident" }) {
//   const [tab, setTab] = useState("register");
//   const filedBy = role;
//   const session = SESSIONS[filedBy];
//   const [form, setForm] = useState({ onBehalfUnit: "", category: CATEGORIES[0], priority: "Medium", desc: "" });
//   const [file, setFile] = useState(null);
//   const [fileError, setFileError] = useState("");
//   const [complaints, setComplaints] = useState([
//     { id: "CMP-2026-4471", filedBy: "Resident", name: "R. Sharma", unit: "B-204", category: "Plumbing", priority: "High", status: "In Review", date: "05 Sep 2026" },
//     { id: "CMP-2026-4409", filedBy: "AOA", name: "On behalf of A-108", unit: "A-108", category: "Common Area", priority: "Low", status: "Resolved", date: "01 Sep 2026" },
//   ]);
//   const [searchId, setSearchId] = useState("");
//   const [confirmedId, setConfirmedId] = useState(null);
//   const fileInputRef = useRef(null);

//   const ALLOWED = ["image/jpeg", "image/jpg", "application/pdf"];

//   function handleFile(e) {
//     const f = e.target.files[0];
//     if (!f) return;
//     if (!ALLOWED.includes(f.type)) {
//       setFileError("Only .jpg and .pdf files are accepted.");
//       setFile(null);
//       fileInputRef.current.value = "";
//       return;
//     }
//     if (f.size > 8 * 1024 * 1024) {
//       setFileError("File must be under 8 MB.");
//       setFile(null);
//       fileInputRef.current.value = "";
//       return;
//     }
//     setFileError("");
//     setFile(f);
//   }

//   function handleSubmit(e) {
//     e.preventDefault();
//     if (!form.desc) return;
//     const id = genId();
//     const entry = {
//       id,
//       filedBy,
//       name: filedBy === "AOA" && form.onBehalfUnit ? `On behalf of ${form.onBehalfUnit}` : session.name,
//       unit: filedBy === "AOA" && form.onBehalfUnit ? form.onBehalfUnit : session.unit,
//       category: form.category,
//       priority: form.priority,
//       status: "Pending",
//       date: new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }),
//     };
//     setComplaints([entry, ...complaints]);
//     setConfirmedId(id);
//     setForm({ onBehalfUnit: "", category: CATEGORIES[0], priority: "Medium", desc: "" });
//     setFile(null);
//     if (fileInputRef.current) fileInputRef.current.value = "";
//   }

//   const found = searchId.trim() ? complaints.filter((c) => c.id.toLowerCase().includes(searchId.trim().toLowerCase())) : complaints;

//   return (
//     <div style={styles.page}>
//       <style>{`
//         * { box-sizing: border-box; }
//         input:focus, textarea:focus, select:focus, button:focus-visible {
//           outline: 2px solid #16302B; outline-offset: 1px;
//         }
//         input::placeholder, textarea::placeholder { color: #9AA6A0; }
//       `}</style>

//       <div style={styles.card}>
//         <header style={styles.header}>
//           <div style={styles.crest}>SR</div>
//           <div>
//             <div style={styles.orgName}>Sunrise Residency</div>
//             <div style={styles.orgSub}>Complaint Register</div>
//           </div>
//         </header>

//         <nav style={styles.tabs}>
//           <button
//             style={{ ...styles.tab, ...(tab === "register" ? styles.tabActive : {}) }}
//             onClick={() => { setTab("register"); setConfirmedId(null); }}
//           >
//             Register complaint
//           </button>
//           <button
//             style={{ ...styles.tab, ...(tab === "track" ? styles.tabActive : {}) }}
//             onClick={() => setTab("track")}
//           >
//             Track status
//           </button>
//         </nav>

//         <div style={styles.body}>
//           {tab === "register" && (
//             confirmedId ? (
//               <div style={styles.confirm}>
//                 <div style={styles.confirmDot} />
//                 <div>
//                   <div style={styles.confirmTitle}>Complaint registered</div>
//                   <div style={styles.confirmId}>{confirmedId}</div>
//                   <div style={styles.confirmNote}>Save this ID to track progress under "Track status".</div>
//                 </div>
//                 <button style={styles.linkBtn} onClick={() => setConfirmedId(null)}>File another</button>
//               </div>
//             ) : (
//               <form onSubmit={handleSubmit} style={styles.form}>
//                 <div style={styles.sessionCard}>
//                   <div style={styles.sessionAvatar}>{session.name.charAt(0)}</div>
//                   <div style={{ flex: 1 }}>
//                     <div style={styles.sessionName}>{session.name}</div>
//                     <div style={styles.sessionMeta}>{session.unit} · {session.phone}</div>
//                   </div>
//                   <span style={styles.sessionTag}>{filedBy === "AOA" ? "AOA login" : "Resident login"}</span>
//                 </div>

//                 {filedBy === "AOA" && (
//                   <div style={styles.field}>
//                     <label style={styles.label}>Resident / unit this is about</label>
//                     <input
//                       style={styles.input}
//                       value={form.onBehalfUnit}
//                       onChange={(e) => setForm({ ...form, onBehalfUnit: e.target.value })}
//                       placeholder="e.g. A-108 (leave blank for a common-area issue)"
//                     />
//                   </div>
//                 )}

//                 <div style={styles.row}>
//                   <div style={{ ...styles.field, flex: 1 }}>
//                     <label style={styles.label}>Category</label>
//                     <select style={styles.input} value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}>
//                       {CATEGORIES.map((c) => <option key={c}>{c}</option>)}
//                     </select>
//                   </div>
//                   <div style={{ ...styles.field, flex: 1 }}>
//                     <label style={styles.label}>Priority</label>
//                     <div style={styles.segment}>
//                       {["Low", "Medium", "High"].map((p) => (
//                         <button
//                           type="button"
//                           key={p}
//                           onClick={() => setForm({ ...form, priority: p })}
//                           style={{ ...styles.segmentBtn, ...(form.priority === p ? styles.segmentBtnActive : {}) }}
//                         >
//                           {p}
//                         </button>
//                       ))}
//                     </div>
//                   </div>
//                 </div>

//                 <div style={styles.field}>
//                   <label style={styles.label}>Description</label>
//                   <textarea style={{ ...styles.input, height: 80, resize: "vertical" }} value={form.desc} onChange={(e) => setForm({ ...form, desc: e.target.value })} placeholder="What happened, and where" required />
//                 </div>

//                 <div style={styles.field}>
//                   <label style={styles.label}>Attach proof — JPG or PDF only</label>
//                   <label style={styles.upload}>
//                     <input ref={fileInputRef} type="file" accept=".jpg,.jpeg,.pdf,image/jpeg,application/pdf" onChange={handleFile} style={{ display: "none" }} />
//                     <span style={styles.uploadIcon}>+</span>
//                     <span>{file ? file.name : "Choose a .jpg or .pdf file"}</span>
//                   </label>
//                   {fileError && <div style={styles.error}>{fileError}</div>}
//                 </div>

//                 <button type="submit" style={styles.submit}>Submit complaint</button>
//               </form>
//             )
//           )}

//           {tab === "track" && (
//             <div>
//               <div style={styles.searchRow}>
//                 <input style={styles.input} value={searchId} onChange={(e) => setSearchId(e.target.value)} placeholder="Search by complaint ID" />
//               </div>
//               <div style={styles.list}>
//                 {found.length === 0 && <div style={styles.empty}>No complaint matches that ID.</div>}
//                 {found.map((c) => {
//                   const s = STATUS_STYLE[c.status];
//                   const p = PRIORITY_STYLE[c.priority] || PRIORITY_STYLE.Medium;
//                   return (
//                     <div key={c.id} style={styles.row2}>
//                       <div>
//                         <div style={styles.rowId}>{c.id}</div>
//                         <div style={styles.rowMeta}>{c.name} · {c.unit} · {c.category}</div>
//                       </div>
//                       <div style={styles.rowRight}>
//                         <div style={{ display: "flex", gap: 5, justifyContent: "flex-end" }}>
//                           <span style={{ ...styles.badge, background: p.bg, color: p.fg }}>{c.priority}</span>
//                           <span style={{ ...styles.badge, background: s.bg, color: s.fg }}>
//                             <span style={{ ...styles.badgeDot, background: s.dot }} />
//                             {c.status}
//                           </span>
//                         </div>
//                         <div style={styles.rowDate}>{c.date}</div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// // ---- Preview harness only (not part of the app) ----
// // In production, `role` comes from your auth/session — each login type
// // lands on this same component with its own role, never a switch.
// export function ComplaintRegisterPreview() {
//   const [previewRole, setPreviewRole] = useState("Resident");
//   return (
//     <div>
//       <div style={styles.previewBar}>
//         <span style={styles.previewLabel}>Preview as:</span>
//         {["Resident", "AOA"].map((r) => (
//           <button
//             key={r}
//             onClick={() => setPreviewRole(r)}
//             style={{ ...styles.previewBtn, ...(previewRole === r ? styles.previewBtnActive : {}) }}
//           >
//             {r} login
//           </button>
//         ))}
//       </div>
//       <ComplaintRegister role={previewRole} />
//     </div>
//   );
// }

// const styles = {
//   previewBar: {
//     display: "flex", alignItems: "center", gap: 8, maxWidth: 460, margin: "0 auto 10px",
//     fontSize: 11.5, color: "#9AA6A0", fontFamily: "Inter, sans-serif",
//   },
//   previewLabel: { fontWeight: 600 },
//   previewBtn: {
//     padding: "4px 10px", borderRadius: 20, border: "1px solid #D2D9D4",
//     background: "#fff", color: "#7C8A82", fontSize: 11.5, cursor: "pointer", fontFamily: "inherit",
//   },
//   previewBtnActive: { background: "#EFE6C9", color: "#8A5A0E", borderColor: "#E6DEC2", fontWeight: 700 },
//   page: {
//     minHeight: "100vh",
//     background: "#EEF1EE",
//     display: "flex",
//     justifyContent: "center",
//     padding: "32px 16px",
//     fontFamily: "Inter, -apple-system, 'Segoe UI', sans-serif",
//     color: "#16302B",
//   },
//   card: {
//     width: "100%",
//     maxWidth: 460,
//     background: "#FFFFFF",
//     borderRadius: 4,
//     border: "1px solid #D8DFDA",
//     overflow: "hidden",
//     height: "fit-content",
//   },
//   header: {
//     display: "flex",
//     alignItems: "center",
//     gap: 12,
//     padding: "18px 20px",
//     borderBottom: "1px solid #E4E9E5",
//   },
//   crest: {
//     width: 38, height: 38, borderRadius: 4,
//     background: "#16302B", color: "#EFE6C9",
//     display: "flex", alignItems: "center", justifyContent: "center",
//     fontFamily: "'Roboto Slab', Georgia, serif", fontWeight: 700, fontSize: 14,
//     flexShrink: 0,
//   },
//   orgName: { fontFamily: "'Roboto Slab', Georgia, serif", fontWeight: 700, fontSize: 17, lineHeight: 1.2 },
//   orgSub: { fontSize: 12.5, color: "#5A6B62", marginTop: 2 },
//   tabs: { display: "flex", borderBottom: "1px solid #E4E9E5" },
//   tab: {
//     flex: 1, padding: "12px 8px", border: "none", background: "transparent",
//     fontSize: 13.5, fontWeight: 600, color: "#7C8A82", cursor: "pointer",
//     borderBottom: "2px solid transparent", fontFamily: "inherit",
//   },
//   tabActive: { color: "#16302B", borderBottom: "2px solid #A97C1F" },
//   body: { padding: "20px" },
//   form: { display: "flex", flexDirection: "column", gap: 14 },
//   row: { display: "flex", gap: 10 },
//   field: { display: "flex", flexDirection: "column", gap: 5, flex: 1 },
//   label: { fontSize: 12.5, fontWeight: 600, color: "#48584F" },
//   input: {
//     padding: "9px 11px", borderRadius: 4, border: "1px solid #D2D9D4",
//     fontSize: 14, fontFamily: "inherit", color: "#16302B", background: "#FCFCFB",
//   },
//   sessionCard: {
//     display: "flex", alignItems: "center", gap: 10, padding: "10px 12px",
//     background: "#F3F0E4", border: "1px solid #E6DEC2", borderRadius: 4,
//   },
//   sessionAvatar: {
//     width: 32, height: 32, borderRadius: "50%", background: "#16302B", color: "#EFE6C9",
//     display: "flex", alignItems: "center", justifyContent: "center",
//     fontFamily: "'Roboto Slab', Georgia, serif", fontWeight: 700, fontSize: 14, flexShrink: 0,
//   },
//   sessionName: { fontSize: 13.5, fontWeight: 700, color: "#16302B" },
//   sessionMeta: { fontSize: 11.5, color: "#7C8A82", marginTop: 1 },
//   sessionTag: { fontSize: 10.5, fontWeight: 700, color: "#8A5A0E", background: "#FBF0DA", padding: "3px 8px", borderRadius: 20, whiteSpace: "nowrap" },
//   segment: { display: "flex", gap: 6 },
//   segmentBtn: {
//     flex: 1, padding: "8px 10px", borderRadius: 4, border: "1px solid #D2D9D4",
//     background: "#FCFCFB", fontSize: 13.5, fontWeight: 600, color: "#5A6B62", cursor: "pointer",
//     fontFamily: "inherit",
//   },
//   segmentBtnActive: { background: "#16302B", color: "#EFE6C9", borderColor: "#16302B" },
//   upload: {
//     display: "flex", alignItems: "center", gap: 8, padding: "10px 12px",
//     border: "1px dashed #B7C2BB", borderRadius: 4, cursor: "pointer",
//     fontSize: 13.5, color: "#48584F", background: "#FBFAF6",
//   },
//   uploadIcon: {
//     width: 20, height: 20, borderRadius: "50%", background: "#E4E9E5",
//     display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, flexShrink: 0,
//   },
//   error: { fontSize: 12, color: "#B0413E", marginTop: 2 },
//   submit: {
//     marginTop: 4, padding: "11px", borderRadius: 4, border: "none",
//     background: "#16302B", color: "#EFE6C9", fontSize: 14.5, fontWeight: 700,
//     cursor: "pointer", fontFamily: "inherit",
//   },
//   confirm: { display: "flex", flexDirection: "column", gap: 8, padding: "10px 2px" },
//   confirmDot: { width: 10, height: 10, borderRadius: "50%", background: "#2F7D5C" },
//   confirmTitle: { fontSize: 13, color: "#5A6B62", fontWeight: 600 },
//   confirmId: { fontFamily: "'Roboto Slab', Georgia, serif", fontSize: 22, fontWeight: 700, color: "#16302B" },
//   confirmNote: { fontSize: 13, color: "#5A6B62", marginTop: 2 },
//   linkBtn: {
//     alignSelf: "flex-start", marginTop: 6, background: "none", border: "none",
//     color: "#A97C1F", fontWeight: 700, fontSize: 13.5, cursor: "pointer", padding: 0, fontFamily: "inherit",
//   },
//   searchRow: { marginBottom: 14 },
//   list: { display: "flex", flexDirection: "column", gap: 8 },
//   empty: { fontSize: 13.5, color: "#7C8A82", padding: "10px 2px" },
//   row2: {
//     display: "flex", justifyContent: "space-between", alignItems: "center",
//     padding: "11px 12px", border: "1px solid #E4E9E5", borderRadius: 4, background: "#FCFCFB",
//   },
//   rowId: { fontFamily: "'Roboto Slab', Georgia, serif", fontWeight: 700, fontSize: 13.5 },
//   rowMeta: { fontSize: 12, color: "#7C8A82", marginTop: 2 },
//   rowRight: { textAlign: "right" },
//   badge: {
//     display: "inline-flex", alignItems: "center", gap: 5, padding: "3px 9px",
//     borderRadius: 20, fontSize: 11.5, fontWeight: 700,
//   },
//   badgeDot: { width: 6, height: 6, borderRadius: "50%" },
//   rowDate: { fontSize: 11, color: "#9AA6A0", marginTop: 3 },
// };




// src/components/ComplaintRegister.jsx
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import configService from "../services/config";
import {
  Alert, Avatar, Box, Button, Chip, CircularProgress, MenuItem,
  Paper, Stack, TextField, ToggleButton, ToggleButtonGroup, Typography,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CloudUploadRoundedIcon from "@mui/icons-material/CloudUploadRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

const PRIORITIES = ["Low", "Medium", "High"];

const appTheme = createTheme({
  palette: {
    primary: { main: "#16302B", contrastText: "#EFE6C9" },
    secondary: { main: "#A97C1F" },
    background: { default: "#EEF1EE", paper: "#FFFFFF" },
    text: { primary: "#16302B", secondary: "#5A6B62" },
  },
  typography: { fontFamily: "Inter, -apple-system, 'Segoe UI', sans-serif" },
  shape: { borderRadius: 8 },
});

const serif = "'Roboto Slab', Georgia, serif";

function FieldLabel({ children }) {
  return (
    <Typography
      sx={{ fontSize: 12.5, fontWeight: 600, color: "#48584F", mb: 0.75, lineHeight: 1.2 }}
    >
      {children}
    </Typography>
  );
}

export default function ComplaintRegister({ role = "Resident", onNavigate }) {
  const filedBy = role === "AOA" ? "AOA" : "Resident";

  // 🔹 Redux — sirf company_id + userId chahiye
  const { company_id, userId } = useSelector(
    (state) => state.globalVariables
  );

  /* -------- Categories -------- */
  const [categories, setCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(false);

  useEffect(() => {
    if (!company_id) return;
    let cancelled = false;

    (async () => {
      setCategoriesLoading(true);
      try {
        const res = await configService.complaintCategories({ company_id });
        const list =
          (Array.isArray(res?.data) && res.data) ||
          (Array.isArray(res?.data?.data) && res.data.data) ||
          [];

        if (cancelled) return;
        setCategories(list);

        if (list.length > 0) {
          setForm((f) => ({ ...f, job_category_id: list[0].id }));
        }
      } catch (err) {
        console.error("❌ Categories fetch error:", err);
        toast.error("Failed to load categories.");
      } finally {
        if (!cancelled) setCategoriesLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [company_id]);

  /* -------- User profile -------- */
  const [profile, setProfile] = useState({ name: "", mobile: "" });

  useEffect(() => {
    if (!userId) return;
    let cancelled = false;

    (async () => {
      try {
        const res = await configService.complaintUserProfile({ customer_id: userId });
        const payload = res?.data?.data || res?.data || {};

        if (cancelled) return;
        setProfile({
          name:   payload.name   || "User",
          mobile: payload.mobile || "—",
        });
      } catch (err) {
        console.error("❌ Profile fetch error:", err);
        if (!cancelled) {
          setProfile((p) => ({ name: p.name || "User", mobile: p.mobile || "—" }));
        }
      }
    })();

    return () => { cancelled = true; };
  }, [userId]);

  /* -------- Form state -------- */
  const [form, setForm] = useState({
    onBehalfUnit: "",
    job_category_id: "",
    priority: "Medium",
    desc: "",
  });
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState("");
  const [descError, setDescError] = useState("");
  const [confirmedId, setConfirmedId] = useState(null);
  const [saving, setSaving] = useState(false);
  const fileInputRef = useRef(null);

  const ALLOWED = ["image/jpeg", "image/jpg", "application/pdf"];

  const setField = (key) => (e) =>
    setForm((f) => ({ ...f, [key]: e.target.value }));

  function handleFile(e) {
    const f = e.target.files?.[0];
    if (!f) return;
    if (!ALLOWED.includes(f.type)) {
      setFileError("Only .jpg and .pdf files are accepted.");
      setFile(null);
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }
    if (f.size > 8 * 1024 * 1024) {
      setFileError("File must be under 8 MB.");
      setFile(null);
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }
    setFileError("");
    setFile(f);
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (!form.desc.trim()) {
      setDescError("Please describe the issue.");
      return;
    }
    setDescError("");

    if (!company_id || !userId) {
      toast.error("Session missing. Please login again.");
      return;
    }

    if (!form.job_category_id) {
      toast.error("Please select a category.");
      return;
    }

    const onBehalf = filedBy === "AOA" && form.onBehalfUnit.trim();
    const finalDescription = onBehalf
      ? `[On behalf of ${onBehalf}] ${form.desc.trim()}`
      : form.desc.trim();

    const fd = new FormData();
    fd.append("company_id", company_id);
    fd.append("customer_id", userId);
    fd.append("job_category_id", form.job_category_id);
    fd.append("priority", form.priority);
    fd.append("description", finalDescription);
    if (file) fd.append("attachment", file);

    try {
      setSaving(true);
      const res = await configService.complaintRegister(fd);

      if (res?.status === true || res?.data?.status === true || res?.status === 201) {
        const payload = res?.data?.data || res?.data || {};
        const refId = payload.complaint_id || payload.reference || "CMP-SUBMITTED";

        toast.success(res?.data?.message || res?.message || "Complaint registered!");
        setConfirmedId(refId);

        setForm({
          onBehalfUnit: "",
          job_category_id: categories[0]?.id || "",
          priority: "Medium",
          desc: "",
        });
        setFile(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
      } else {
        toast.error(res?.data?.message || res?.message || "Failed to save complaint.");
      }
    } catch (error) {
      console.error("❌ Complaint Register Error:", error);
      toast.error(
        `Error: ${error?.response?.data?.message || error?.message || "Server Error"}`
      );
    } finally {
      setSaving(false);
    }
  }

  return (
    <ThemeProvider theme={appTheme}>
      <Box
        sx={{
          minHeight: "100vh",
          bgcolor: "background.default",
          display: "flex",
          justifyContent: "center",
          px: 2,
          py: 4,
        }}
      >
        <Box sx={{ width: "100%", maxWidth: 460 }}>
          <Paper
            elevation={0}
            sx={{ border: "1px solid #D8DFDA", borderRadius: 2, overflow: "hidden" }}
          >
            {/* ❌ Header removed — koi "Work Sphere" / company_name nahi */}

            <Box sx={{ p: 2.5 }}>
              {confirmedId ? (
                <Stack spacing={1} sx={{ py: 1 }}>
                  <CheckCircleRoundedIcon sx={{ color: "#2F7D5C", fontSize: 34 }} />
                  <Typography sx={{ fontSize: 13, fontWeight: 600, color: "text.secondary" }}>
                    Complaint registered
                  </Typography>
                  <Typography sx={{ fontFamily: serif, fontWeight: 700, fontSize: 24 }}>
                    {confirmedId}
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: "text.secondary" }}>
                    Save this ID to track progress under "Track status".
                  </Typography>

                  <Stack direction="row" spacing={1} sx={{ pt: 1.5 }}>
                    <Button
                      variant="outlined"
                      onClick={() => setConfirmedId(null)}
                      sx={{ textTransform: "none", fontWeight: 700 }}
                    >
                      File another
                    </Button>
                    {onNavigate && (
                      <Button
                        variant="contained"
                        onClick={() => onNavigate("track")}
                        sx={{ textTransform: "none", fontWeight: 700 }}
                      >
                        Track status
                      </Button>
                    )}
                  </Stack>
                </Stack>
              ) : (
                <Stack component="form" onSubmit={handleSubmit} spacing={2}>
                  {/* Session card — user name + mobile */}
                  <Paper
                    variant="outlined"
                    sx={{ p: 1.5, borderRadius: 2, bgcolor: "#F3F0E4", borderColor: "#E6DEC2" }}
                  >
                    <Stack direction="row" spacing={1.25} alignItems="center">
                      <Avatar
                        sx={{
                          width: 34, height: 34, bgcolor: "#16302B", color: "#EFE6C9",
                          fontFamily: serif, fontWeight: 700, fontSize: 14,
                        }}
                      >
                        {(profile.name || "U").charAt(0).toUpperCase()}
                      </Avatar>
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography sx={{ fontSize: 13.5, fontWeight: 700 }}>
                          {profile.name || "Loading..."}
                        </Typography>
                        <Typography sx={{ fontSize: 11.5, color: "text.secondary" }}>
                          {profile.mobile || "—"}
                        </Typography>
                      </Box>
                      <Chip
                        size="small"
                        label={filedBy === "AOA" ? "AOA login" : "Resident login"}
                        sx={{
                          bgcolor: "#FBF0DA", color: "#8A5A0E",
                          fontWeight: 700, fontSize: 10.5, height: 22,
                        }}
                      />
                    </Stack>
                  </Paper>

                  {filedBy === "AOA" && (
                    <Box>
                      <FieldLabel>Resident / unit this is about</FieldLabel>
                      <TextField
                        placeholder="e.g. A-108 (blank for common area)"
                        size="small"
                        fullWidth
                        value={form.onBehalfUnit}
                        onChange={setField("onBehalfUnit")}
                      />
                    </Box>
                  )}

                  <Stack direction="row" spacing={1.5} alignItems="flex-start">
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <FieldLabel>Category</FieldLabel>
                      <TextField
                        select
                        size="small"
                        fullWidth
                        value={form.job_category_id}
                        onChange={setField("job_category_id")}
                        disabled={categoriesLoading}
                        SelectProps={{ MenuProps: { disablePortal: true } }}
                      >
                        {categoriesLoading ? (
                          <MenuItem value="">Loading...</MenuItem>
                        ) : categories.length === 0 ? (
                          <MenuItem value="">No categories</MenuItem>
                        ) : (
                          categories.map((c) => (
                            <MenuItem key={c.id} value={c.id}>
                              {c.name}
                            </MenuItem>
                          ))
                        )}
                      </TextField>
                    </Box>

                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <FieldLabel>Priority</FieldLabel>
                      <ToggleButtonGroup
                        exclusive
                        fullWidth
                        size="small"
                        value={form.priority}
                        onChange={(_, val) =>
                          val && setForm((f) => ({ ...f, priority: val }))
                        }
                        sx={{
                          gap: 0.5,
                          "& .MuiToggleButtonGroup-grouped": {
                            border: "1px solid #D2D9D4 !important",
                            borderRadius: "4px !important",
                            height: 40, px: 0, textTransform: "none",
                            fontWeight: 600, fontSize: 13, color: "#5A6B62",
                            bgcolor: "#FCFCFB",
                            "&:hover": { bgcolor: "#F3F0E4" },
                          },
                          "& .MuiToggleButtonGroup-grouped.Mui-selected": {
                            bgcolor: "#16302B", color: "#EFE6C9",
                            "&:hover": { bgcolor: "#1F4239" },
                          },
                        }}
                      >
                        {PRIORITIES.map((p) => (
                          <ToggleButton key={p} value={p}>{p}</ToggleButton>
                        ))}
                      </ToggleButtonGroup>
                    </Box>
                  </Stack>

                  <Box>
                    <FieldLabel>Description</FieldLabel>
                    <TextField
                      placeholder="What happened, and where"
                      multiline
                      minRows={3}
                      fullWidth
                      size="small"
                      value={form.desc}
                      onChange={setField("desc")}
                      error={Boolean(descError)}
                      helperText={descError}
                    />
                  </Box>

                  <Box>
                    <FieldLabel>Attach proof — JPG or PDF only</FieldLabel>
                    <Button
                      component="label"
                      variant="outlined"
                      startIcon={<CloudUploadRoundedIcon />}
                      fullWidth
                      sx={{
                        justifyContent: "flex-start",
                        textTransform: "none",
                        fontWeight: 500,
                        py: 1.25,
                        borderStyle: "dashed",
                        borderColor: "#B7C2BB",
                        bgcolor: "#FBFAF6",
                        color: "text.primary",
                        "&:hover": {
                          borderStyle: "dashed",
                          borderColor: "#8E9C94",
                          bgcolor: "#F7F6F1",
                        },
                      }}
                    >
                      {file ? file.name : "Choose a .jpg or .pdf file"}
                      <input
                        ref={fileInputRef}
                        hidden
                        type="file"
                        accept=".jpg,.jpeg,.pdf,image/jpeg,application/pdf"
                        onChange={handleFile}
                      />
                    </Button>

                    {fileError && (
                      <Alert severity="error" sx={{ mt: 1, py: 0 }}>
                        {fileError}
                      </Alert>
                    )}
                  </Box>

                  <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    disabled={saving}
                    startIcon={
                      saving ? (
                        <CircularProgress size={16} sx={{ color: "#EFE6C9" }} />
                      ) : null
                    }
                    sx={{
                      py: 1.25,
                      textTransform: "none",
                      fontSize: 14.5,
                      fontWeight: 700,
                    }}
                  >
                    {saving ? "Submitting..." : "Submit complaint"}
                  </Button>
                </Stack>
              )}
            </Box>
          </Paper>

          {onNavigate && !confirmedId && (
            <Button
              fullWidth
              startIcon={<SearchRoundedIcon />}
              onClick={() => onNavigate("track")}
              sx={{ mt: 1.5, textTransform: "none", fontWeight: 700 }}
            >
              Track an existing complaint
            </Button>
          )}
        </Box>
      </Box>
    </ThemeProvider>
  );
}